import Vue from 'vue'
import Component from 'vue-class-component'
import postStore from '../../store/post/post-store'
import StatementView from '../statement/StatementView.vue'
import SaveButton from '@/components/buttons/SaveButton.vue'
import ClearButton from '@/components/buttons/ClearButton.vue'
import LoginButton from '@/components/buttons/LoginButton';
import { focus } from 'vue-focus';
import RichText from '@/components/shared/RichText';
import authStore from '@/store/auth/auth-store';

@Component({
  directives: { focus: focus },
  name: 'feedback-add',
  components: {
    'login-button': LoginButton,
    'statement-view': StatementView,
    'save-button': SaveButton,
    'clear-button': ClearButton,
    'rich-text': RichText
  }
})
export default class FeedbackAdd extends Vue {
  protected inputFocused = true;

  mounted (): void {
    console.log('FeedbackAdd.ts: mounted')

    this.$store.subscribe((mutation, state) => {
      console.log('FeedbackAdd mutation: type = %j', mutation.type)
      if (mutation.type === 'feed/setType') {
        console.log('FeedbackAdd mutation: payload = %j', mutation.payload)
        if(mutation.payload.type === 'post-edit') {
          this.inputFocused = true;
        }
      }
    })
  }

  get isAuthenticated():boolean {return authStore.isAuthenticated}

  get feedbackForm () { return postStore.state.postForm }

  get isFeedbackSuccess() { return postStore.postSuccess }

  protected resetForm() : void {
    postStore.dispatchResetPostForm()
  }

  protected addFeedback (): void {
    postStore.dispatchAddPost()
  }
}
